
import Input from "../Input";
import Output from "../Output";
import switchImage from "../../assets/switch.png";
import { Helmet } from 'react-helmet-async';


import { Link } from "react-router-dom";
import bolgar from "../../assets/bolgar.png";
import magyar from "../../assets/magyar.png";
import arrow from "../../assets/arrow.png"


function BolgarMagyar({ handleText, output, handleTarget, handleSource, langs, handleSwap, handleTranslate, text }) {


    return (

        <>
            <Helmet>
                <title>Bolgár magyar fordító</title>
                <meta name='description' content="Ingyenes bolgár magyar fordító szavakra, kifejezésekre, mondatokra. Akár teljes szöveg fordítása is." />
                <meta title="Bolgár magyar fordító" />
                <link rel="canonical" href="https://online-fordito.hu/bolgar-magyar-fordito" />
            </Helmet>
            <h1>Bolgár magyar fordító</h1>
            <div className="wrapper">
                <div>
                    <Input handleText={handleText} handleSource={handleSource} langs={langs} text={text}></Input>
                    <button className="transbutton" onClick={handleTranslate}>Fordítás</button>
                </div>

                <button className="switch" onClick={handleSwap}><img src={switchImage}></img></button>


                <Output output={output} handleTarget={handleTarget} langs={langs} />

            </div>


            <section>

                <div className="sectionhead">
                    <h2>A bolgár nyelv</h2>
                    <img src={bolgar} alt="Bolgár zászló"></img>
                </div>

                <p>A bolgár egy szláv nyelv, amelyet körülbelül 9 millió ember beszél, elsősorban Bulgáriában, ahol ez a hivatalos nyelv. A bolgár nyelvet a különböző országokban, többek között Görögországban, Törökországban, Ukrajnában és az Egyesült Államokban élő bolgár közösségek is beszélik. Itt egy áttekintés a bolgár nyelvről:</p>

                <p><b>Történelmi háttér</b>: A bolgár a szláv nyelvcsalád délszláv ágának tagja, amelybe olyan nyelvek is tartoznak, mint a szerb, a horvát és a szlovén. Gyökerei az óbolgár nyelvben, más néven óegyházi szláv nyelvben gyökereznek, amelyet a 9. században Szent Cirill és Metód tanítványai fejlesztettek ki. A bolgár az idők során jelentős változásokon ment keresztül, és különböző nyelvi és történelmi tényezők befolyásolták.</p>

                <p><b>Cirill betűs írás</b>: A bolgár nyelvet cirill betűkkel írják, amelyet Szent Cirill és Metód találtak ki. A bolgár cirill ábécé 30 betűből áll, és hasonló más szláv cirill ábécékhez, mint például az orosz és a szerb. Bulgáriában hivatalosan a 9. században fogadták el, és azóta némi módosításon ment keresztül.</p>

                <p><b>Nyelvi jellemzők</b>: A bolgár nyelvnek számos olyan nyelvi sajátossága van, amely megkülönbözteti a többi szláv nyelvtől. A főnevek deklinációjának összetett rendszere van, három nyelvtani nemmel (hímnemű, nőnemű és semleges) és hét esettel. A bolgár nyelv gazdag igei rendszerrel is rendelkezik, különböző idő- és hangnemekkel, valamint aspektusokkal. A nyelv nagy hangsúlyt fektet a szóhangsúlyra, és a szavak kiejtése a hangsúlymintától függően változhat.</p>


                <p><b>Bolgár nyelvjárások</b>: A bolgár nyelvjárások a nyelv sokszínűségének lényeges részét képezik. Három fő csoportba sorolhatók: Keleti, nyugati és rodopei nyelvjárások. A nyelvjárások a szókincs, a kiejtés és a nyelvtan tekintetében különböznek egymástól. A standard bolgár nyelv, amely a fővárosban, Szófiában beszélt nyelvjáráson alapul, széles körben érthető és hivatalos nyelvként használatos Bulgáriában.</p>

                <p><b>Befolyás és kölcsönzések</b>: Történelme során a bolgár nyelvre más nyelvek is hatással voltak, különösen a különböző civilizációk kereszteződésében való földrajzi elhelyezkedése miatt. Számos nyelvből kölcsönzött szavakat, többek között a görögből, a törökből, az oroszból és a franciából. Emellett az oszmán uralom alatt török kölcsönszavak is beépültek a bolgár szókincsbe.</p>

                <p><b>Kulturális jelentősége</b>: A bolgár nyelv és irodalom fontos szerepet játszott a bolgár kultúra és identitás kialakításában. A bolgár irodalom gazdag hagyományokkal rendelkezik, amelyek a középkorig nyúlnak vissza, és olyan neves személyiségek, mint Ivan Vazov, Hristo Botev és Elias Canetti jelentős mértékben hozzájárultak az irodalom világához. A nyelv a bolgár folklór, hagyományok és történelmi elbeszélések kifejezőeszközeként szolgál.</p>

                <p><b>Modern használat</b>: A bolgár nyelvet beszéli a lakosság többsége Bulgáriában, és ez az oktatás, a média és a közigazgatás elsődleges nyelve az országban. A szomszédos országokban, ahol bolgár közösségek élnek, kisebbségi nyelvként is elismerik. A nyelv modernizálódott és a mai igényekhez igazodott, új terminológiával bővült különböző területeken, például a technológia, a tudomány és az üzleti élet területén.</p>

                <p>A bolgár egy lenyűgöző nyelv, gazdag történelmi és kulturális örökséggel. Egyedülálló nyelvi jellemzői, változatos nyelvjárásai és az irodalomhoz való jelentős hozzájárulása a bolgár identitás szerves részévé és a nyelvtanulók és kutatók számára egyaránt érdekes témává teszik.</p>

                <div className="sectionbottom">
                    <Link to="/magyar-bolgar-fordito">Magyar bolgár fordító</Link>

                    <img src={bolgar} alt="bolgár zászló"></img>
                    <img src={arrow} alt=">"></img>
                    <img src={magyar} alt="magyar zászló"></img>

                </div>

            </section>
        </>

    )
}

export default BolgarMagyar;